import { render, staticRenderFns } from "./SubCardToggleButton.vue?vue&type=template&id=792c86ee&scoped=true&"
import script from "./SubCardToggleButton.vue?vue&type=script&lang=js&"
export * from "./SubCardToggleButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792c86ee",
  null
  
)

export default component.exports